export function createEntityMiddleware() {
  return ({ getState }) => next => action => {
    if (action.entities) {
      // eslint-disable-next-line no-param-reassign
      action.entities.state = getState().entities
    }
    return next(action)
  }
}
